import React, { ReactNode } from "react";
import { Calendar } from "primereact/calendar";

interface CalendarInputProps {
    label: any;
    icon: ReactNode;
    placeholder?: string;
    value: Date | null;
    onChange: (date: Date | null) => void;
    errorMessage?: string;
    
}

const CalendarInput: React.FC<CalendarInputProps> = ({ label, icon, placeholder, value, onChange, errorMessage }) => {
    return (
        <div className="relative">
            <div className={`absolute z-10 -top-2 left-[14px] text-[12px] uppercase bg-white px-[4px] py-[2px] transition-all max-[576px]:text-[10px] ${
                value ? "text-[#3b49c0]" : "text-violet-300"
            }`}>
                {label}
            </div>
            <div className="relative">
                <span className="absolute z-10 left-[14px] top-1/2 -translate-y-1/2">{icon}</span>
                <Calendar 
                    value={value} 
                    onChange={(e) => onChange(e.value ?? null)} 
                    placeholder={placeholder} 
                />
            </div>
            {errorMessage && <div className="text-red-500 text-sm mt-2">{errorMessage}</div>}
        </div>
    );
};


export default CalendarInput;
